import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import Sport from "./modules/Sport";
import Leagues from "./modules/Leagues";
import ObjectHelper from "../../helpers/ObjectHelper";
import {Link, withRouter} from "react-router-dom";
import _ from "lodash";
import $ from "jquery";
import ReactDOM from "react-dom";

class LineSelect extends Component {
	state = {
		data     : {
			leagues : []
		},
		selected : {},
		fetching : true
	};

	constructor(props) {
		super(props);

		this.selectAllHandler = this.selectAllHandler.bind(this);
		this.checkEventHandler = this.checkEventHandler.bind(this);
	}

	componentWillMount() {
		this.loadData(this.props.sports);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			fetching : !this.state.fetching
		});

		this.loadData(nextProps.sports);
	}

	loadData(sports) {
		Xhr.getLineSelect(sports).then((resp) => this.setState({data : resp.data, fetching : false}, () => {
			//console.log($('input[id^="line-league-"]'));
		}));
	}

	selectAllHandler() {
		let selected = this.state.selected;

		const {leagues} = this.state.data.leagues;
		leagues.forEach((league) => {
			selected = ObjectHelper.toggleData(selected, league.id)
		});

		this.setState({selected});
	}

	checkEventHandler(e) {
		let selected = this.state.selected;
		const leagueId = e.target.value;
		selected = ObjectHelper.toggleData(selected, leagueId);

		const $element = $(e.target);
		const div = document.createElement('div');

		const showElement = ReactDOM.render(
			<div onClick={this.show.bind(this)} className="show-btn animated fadeIn">Показать:&nbsp;{Object.keys(selected).length}</div>, div);

		if ( Object.keys(selected).length > 0 ) {
			$('.show-btn').remove();
			$(showElement).insertBefore($element.parent());
		}
		else {
			$('.show-btn').remove();
		}

		this.setState({selected});
	}

	show() {
		let selected = this.state.selected;
		this.props.history.push(`/line-leagues/${ObjectHelper.join(selected, '-')}`)
	}

	render() {
		const {sports, leagues} = this.state.data.leagues;
		const {selected, fetching} = this.state;

		if ( fetching ) {
			return <Loading/>;
		}

		const sortedSports = _.sortBy(sports, s => s.name);

		const tmp = sortedSports.map((sport) => {
			return (
				<Sport key={`line-select-sport-${sport.id}`} sport={sport}>
					<Leagues sport={sport} leagues={leagues}
					         checkHandler={this.checkEventHandler}
					         selected={this.state.selected}/>
				</Sport>
			);
		});

		return (
			<div key="line-select" className="body__container__side-right">
				<div className="profile__header">
					<div>Турниры</div>
				</div>

				<div className="live-event-selector">
					<div className="buttons live-event-selector__buttons">
						<Link to={`/line-leagues/${ObjectHelper.join(selected, '-')}`} className="buttons__show gray">
							<span>Показать</span>
							<span className="sup">{ObjectHelper.count(selected)}</span>
						</Link>
						{/*<button onClick={this.selectAllHandler} className="buttons__clear live-event-selector__buttons-select_all">*/}
						{/*Выбрать все*/}
						{/*</button>*/}
					</div>
				</div>

				{tmp}

			</div>
		);
	}
}

export default withRouter(LineSelect);


// WEBPACK FOOTER //
// ./src/app/pages/LineSelect/LineSelectContainer.js